(function () {
  'use strict';

  const ROOT_SELECTOR = '[data-soaked-bundle-builder]';

  class SoakedNativeBundle {
    constructor(root) {
      this.root = root;

      this.configEl = root.querySelector(
        '[data-soaked-bundle-config]'
      );

      this.contentEl = root.querySelector(
        '.soaked-bundle-builder__content'
      );

      this.stepsEl = root.querySelector(
        '[data-soaked-bundle-steps]'
      );

      this.optionsEl = root.querySelector(
        '[data-soaked-bundle-options]'
      );

      this.priceEl = root.querySelector(
        '[data-soaked-bundle-price]'
      );

      this.formEl = root.querySelector(
        '.soaked-bundle-builder__form'
      );

      this.variantInput = root.querySelector(
        '[data-soaked-bundle-variant-input]'
      );

      this.submitEl = root.querySelector(
        '[data-soaked-bundle-submit]'
      );

      this.messageEl = root.querySelector(
        '[data-soaked-bundle-message]'
      );

      this.currentPriceEl = root.querySelector(
        '[data-soaked-bundle-current-price]'
      );

      this.comparePriceEl = root.querySelector(
        '[data-soaked-bundle-compare-price]'
      );

      this.config = null;

      this.steps = [];
      this.parentOptions = [];
      this.parentVariants = [];

      this.activeStepIndex = 0;

      /*
       * stepIndex => selected child variant ID
       */
      this.selectedChildVariants = [];

      this.init();
    }


    /* ========================================================
       INIT
    ======================================================== */

    init() {
      if (!this.configEl) {
        return;
      }

      try {
        this.config = JSON.parse(
          this.configEl.textContent
        );
      } catch (error) {
        console.error(
          '[SOAKED Bundle] Invalid configuration:',
          error
        );

        this.showMessage(
          'Bundle configuration could not be loaded.'
        );

        return;
      }

      this.steps = Array.isArray(
        this.config.steps
      )
        ? this.config.steps
        : [];

      this.parentOptions = Array.isArray(
        this.config.parentOptions
      )
        ? this.config.parentOptions
        : [];

      this.parentVariants = Array.isArray(
        this.config.parentVariants
      )
        ? this.config.parentVariants
        : [];

      if (!this.steps.length) {
        this.showMessage(
          'Bundle products are unavailable.'
        );

        return;
      }

      if (!this.parentVariants.length) {
        this.showMessage(
          'Bundle variants are unavailable.'
        );

        return;
      }

      /*
       * Move price above the tabs.
       *
       * Since the bundle block itself comes after
       * Title + Judge.me in product.bundle.json,
       * the visible order becomes:
       *
       * Title
       * Reviews
       * Price
       * Tabs
       * Options
       */
      this.movePriceToTop();

      this.setInitialSelections();
      this.bindForm();
      this.render();
    }


    /* ========================================================
       PRICE POSITION
    ======================================================== */

    movePriceToTop() {
      if (
        !this.contentEl ||
        !this.priceEl ||
        !this.stepsEl
      ) {
        return;
      }

      this.contentEl.insertBefore(
        this.priceEl,
        this.stepsEl
      );
    }


    /* ========================================================
       INITIAL SELECTIONS
    ======================================================== */

    setInitialSelections() {
      let urlVariantId = null;
      try { urlVariantId = new URLSearchParams(window.location.search).get('variant'); } catch (e) {}
      const urlVariant = urlVariantId ? this.parentVariants.find((variant) => String(variant.id) === String(urlVariantId)) : null;
      const initialParentVariant =
        urlVariant ||
        this.parentVariants.find(
          (variant) => variant.available
        ) || this.parentVariants[0];

      this.selectedChildVariants =
        this.steps.map((step) => {
          const variants = Array.isArray(
            step.variants
          )
            ? step.variants
            : [];

          if (!variants.length) {
            return null;
          }

          /*
           * Step linked to a Shopify Bundle parent option.
           *
           * Example:
           * BODY LOTION (SCENT)
           */
          if (
            step.parentOptionPosition !== null &&
            step.parentOptionPosition !== undefined &&
            initialParentVariant &&
            Array.isArray(initialParentVariant.options)
          ) {
            const parentOptionIndex =
              Number(
                step.parentOptionPosition
              ) - 1;

            const initialParentValue =
              initialParentVariant.options[
                parentOptionIndex
              ];

            const matchingChild =
              variants.find(
                (childVariant) => {
                  return (
                    String(
                      childVariant.parentValue
                    ) ===
                    String(
                      initialParentValue
                    )
                  );
                }
              );

            if (matchingChild) {
              return matchingChild.id;
            }
          }

          /*
           * Fixed component.
           *
           * Example:
           * BODY WASH has only one allowed variant,
           * so Shopify may not create a parent option.
           */
          const firstAvailable =
            variants.find(
              (variant) =>
                variant.available !== false
            );

          return firstAvailable
            ? firstAvailable.id
            : variants[0].id;
        });
    }


    /* ========================================================
       RENDER
    ======================================================== */

    render() {
      this.renderSteps();
      this.renderActiveStep();
      this.updateParentVariant();
    }


    /* ========================================================
       STEP TABS
    ======================================================== */

    renderSteps() {
      if (!this.stepsEl) {
        return;
      }

      this.stepsEl.innerHTML = '';

      this.steps.forEach(
        (step, index) => {
          const button =
            document.createElement(
              'button'
            );

          button.type = 'button';

          button.className =
            'soaked-bundle-step';

          button.id =
            `soaked-bundle-tab-${this.config.productId}-${index}`;

          button.setAttribute(
            'role',
            'tab'
          );

          button.setAttribute(
            'aria-selected',
            index ===
              this.activeStepIndex
              ? 'true'
              : 'false'
          );

          button.setAttribute(
            'aria-controls',
            `soaked-bundle-panel-${this.config.productId}`
          );

          button.textContent =
            step.productTitle ||
            `STEP ${index + 1}`;

          if (
            index ===
            this.activeStepIndex
          ) {
            button.classList.add(
              'is-active'
            );
          }

          if (
            this.selectedChildVariants[
              index
            ]
          ) {
            button.classList.add(
              'is-complete'
            );
          }

          button.addEventListener(
            'click',
            () => {
              this.activeStepIndex =
                index;

              this.render();
            }
          );

          this.stepsEl.appendChild(
            button
          );
        }
      );
    }


    /* ========================================================
       ACTIVE STEP
    ======================================================== */

    renderActiveStep() {
      if (!this.optionsEl) {
        return;
      }

      this.optionsEl.innerHTML = '';

      const step =
        this.steps[
          this.activeStepIndex
        ];

      if (!step) {
        return;
      }

      this.optionsEl.id =
        `soaked-bundle-panel-${this.config.productId}`;

      this.optionsEl.setAttribute(
        'role',
        'tabpanel'
      );

      this.optionsEl.setAttribute(
        'aria-labelledby',
        `soaked-bundle-tab-${this.config.productId}-${this.activeStepIndex}`
      );

      const variants =
        Array.isArray(
          step.variants
        )
          ? step.variants
          : [];

      if (!variants.length) {
        const empty =
          document.createElement(
            'div'
          );

        empty.className =
          'soaked-bundle-builder__empty';

        empty.textContent =
          'No options available.';

        this.optionsEl.appendChild(
          empty
        );

        return;
      }

      variants.forEach(
        (variant) => {
          const optionButton =
            this.createVariantOption(
              step,
              variant,
              this.activeStepIndex
            );

          this.optionsEl.appendChild(
            optionButton
          );
        }
      );
    }


    /* ========================================================
       VARIANT OPTION
    ======================================================== */

    createVariantOption(
      step,
      variant,
      stepIndex
    ) {
      const button =
        document.createElement(
          'button'
        );

      button.type = 'button';

      button.className =
        'soaked-bundle-option';

      button.dataset.stepIndex =
        String(stepIndex);

      button.dataset.productId =
        String(step.productId);

      button.dataset.variantId =
        String(variant.id);

      const selected =
        String(
          this.selectedChildVariants[
            stepIndex
          ]
        ) ===
        String(variant.id);

      if (selected) {
        button.classList.add(
          'is-selected'
        );

        button.setAttribute(
          'aria-pressed',
          'true'
        );
      } else {
        button.setAttribute(
          'aria-pressed',
          'false'
        );
      }

      if (
        variant.available === false
      ) {
        button.disabled = true;

        button.setAttribute(
          'aria-disabled',
          'true'
        );
      }


      /* ---------- Radio ---------- */

      const radio =
        document.createElement(
          'span'
        );

      radio.className =
        'soaked-bundle-option__radio';

      radio.setAttribute(
        'aria-hidden',
        'true'
      );


      /* ---------- Content ---------- */

      const content =
        document.createElement(
          'span'
        );

      content.className =
        'soaked-bundle-option__content';


      /* ---------- Variant title ---------- */

      const title =
        document.createElement(
          'span'
        );

      title.className =
        'soaked-bundle-option__title';

      title.textContent =
        this.cleanVariantTitle(
          variant.title
        );

      content.appendChild(
        title
      );


      /* ---------- Scent details ---------- */

      if (
        variant.detailsHtml
      ) {
        const details =
          document.createElement(
            'div'
          );

        details.className =
          'soaked-bundle-option__details';

        details.innerHTML =
          variant.detailsHtml;

        content.appendChild(
          details
        );
      }


      button.appendChild(
        radio
      );

      button.appendChild(
        content
      );


      button.addEventListener(
        'click',
        () => {
          if (
            variant.available ===
            false
          ) {
            return;
          }

          this.selectChildVariant(
            stepIndex,
            variant.id
          );
        }
      );

      return button;
    }


    cleanVariantTitle(title) {
      const value =
        String(
          title || ''
        ).trim();

      if (
        !value ||
        value ===
          'Default Title' ||
        value ===
          'Default'
      ) {
        return 'SELECTED';
      }

      return value;
    }


    /* ========================================================
       SELECT CHILD VARIANT
    ======================================================== */

    selectChildVariant(
      stepIndex,
      childVariantId
    ) {
      this.selectedChildVariants[
        stepIndex
      ] = childVariantId;

      this.clearMessage();

      /*
       * Stay on current step.
       * No automatic next-step movement.
       */
      this.render();
    }


    /* ========================================================
       GET SELECTED CHILD VARIANT
    ======================================================== */

    getSelectedChildVariant(
      stepIndex
    ) {
      const step =
        this.steps[stepIndex];

      if (!step) {
        return null;
      }

      const variants =
        Array.isArray(
          step.variants
        )
          ? step.variants
          : [];

      const selectedId =
        this.selectedChildVariants[
          stepIndex
        ];

      return (
        variants.find(
          (variant) =>
            String(
              variant.id
            ) ===
            String(
              selectedId
            )
        ) || null
      );
    }


    /* ========================================================
       BUILD PARENT OPTION VALUES
    ======================================================== */

    getSelectedParentOptions() {
      const fallbackVariant =
        this.parentVariants.find(
          (variant) =>
            variant.available
        ) ||
        this.parentVariants[0];

      const selectedParentOptions =
        fallbackVariant &&
        Array.isArray(
          fallbackVariant.options
        )
          ? [
              ...fallbackVariant.options
            ]
          : [];

      this.steps.forEach(
        (step, stepIndex) => {
          /*
           * Fixed bundle component.
           * No Shopify parent option required.
           */
          if (
            step.parentOptionPosition ===
              null ||
            step.parentOptionPosition ===
              undefined
          ) {
            return;
          }

          const childVariant =
            this.getSelectedChildVariant(
              stepIndex
            );

          if (!childVariant) {
            return;
          }

          const parentIndex =
            Number(
              step.parentOptionPosition
            ) - 1;

          selectedParentOptions[
            parentIndex
          ] =
            childVariant.parentValue ||
            childVariant.title;
        }
      );

      return selectedParentOptions;
    }


    /* ========================================================
       FIND SHOPIFY BUNDLE PARENT VARIANT
    ======================================================== */

    findSelectedParentVariant() {
      const selectedOptions =
        this.getSelectedParentOptions();

      if (
        !selectedOptions.length
      ) {
        return null;
      }

      return (
        this.parentVariants.find(
          (parentVariant) => {
            if (
              !Array.isArray(
                parentVariant.options
              )
            ) {
              return false;
            }

            if (
              parentVariant.options
                .length !==
              selectedOptions.length
            ) {
              return false;
            }

            return parentVariant.options.every(
              (
                value,
                index
              ) => {
                return (
                  String(value) ===
                  String(
                    selectedOptions[
                      index
                    ]
                  )
                );
              }
            );
          }
        ) || null
      );
    }


    /* ========================================================
       UPDATE SHOPIFY BUNDLE VARIANT
    ======================================================== */

    updateParentVariant() {
      const parentVariant =
        this.findSelectedParentVariant();

      if (!parentVariant) {
        if (this.submitEl) {
          this.submitEl.disabled =
            true;
        }

        this.showMessage(
          'This bundle combination is unavailable.'
        );

        return;
      }

      if (this.variantInput) {
        this.variantInput.value =
          parentVariant.id;
      }

      this.updatePrice(
        parentVariant
      );

      const available =
        parentVariant.available !==
          false &&
        this.areSelectedChildrenAvailable();

      if (this.submitEl) {
        this.submitEl.disabled =
          !available;

        this.submitEl.textContent =
          available
            ? 'ADD BUNDLE TO CART'
            : 'SOLD OUT';
      }

      if (!available) {
        this.showMessage(
          'This bundle combination is sold out.'
        );
      } else {
        this.clearMessage();
      }
    }


    /* ========================================================
       CHILD AVAILABILITY
    ======================================================== */

    areSelectedChildrenAvailable() {
      return this.steps.every(
        (
          step,
          stepIndex
        ) => {
          const childVariant =
            this.getSelectedChildVariant(
              stepIndex
            );

          return (
            childVariant &&
            childVariant.available !==
              false
          );
        }
      );
    }


    /* ========================================================
       PRICE
    ======================================================== */

    updatePrice(
      parentVariant
    ) {
      if (
        this.currentPriceEl
      ) {
        this.currentPriceEl.textContent =
          parentVariant.priceFormatted ||
          '';
      }

      if (
        !this.comparePriceEl
      ) {
        return;
      }

      const compareAt =
        Number(
          parentVariant.compareAtPrice ||
          0
        );

      const price =
        Number(
          parentVariant.price ||
          0
        );

      if (
        compareAt > 0 &&
        compareAt > price
      ) {
        this.comparePriceEl.textContent =
          parentVariant
            .compareAtPriceFormatted ||
          '';

        this.comparePriceEl.hidden =
          false;
      } else {
        this.comparePriceEl.textContent =
          '';

        this.comparePriceEl.hidden =
          true;
      }
    }


    /* ========================================================
       PRODUCT FORM
    ======================================================== */

    bindForm() {
      if (!this.formEl) {
        return;
      }

      this.formEl.addEventListener(
        'submit',
        (event) => {
          const parentVariant =
            this.findSelectedParentVariant();

          if (!parentVariant) {
            event.preventDefault();

            this.showMessage(
              'Please select an available bundle.'
            );

            return;
          }

          if (
            parentVariant.available ===
              false ||
            !this.areSelectedChildrenAvailable()
          ) {
            event.preventDefault();

            this.showMessage(
              'This bundle combination is sold out.'
            );

            return;
          }

          if (
            this.variantInput
          ) {
            this.variantInput.value =
              parentVariant.id;
          }
        }
      );
    }


    /* ========================================================
       MESSAGE
    ======================================================== */

    showMessage(message) {
      if (!this.messageEl) {
        return;
      }

      this.messageEl.textContent =
        message || '';
    }


    clearMessage() {
      if (!this.messageEl) {
        return;
      }

      this.messageEl.textContent =
        '';
    }
  }


  /* ==========================================================
     INITIALIZE
  ========================================================== */

  function initialize() {
    document
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach((root) => {
        if (
          root.dataset
            .soakedNativeBundleInitialized ===
          'true'
        ) {
          return;
        }

        root.dataset
          .soakedNativeBundleInitialized =
          'true';

        new SoakedNativeBundle(
          root
        );
      });
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }


  document.addEventListener(
    'shopify:section:load',
    initialize
  );
})();